import { render, staticRenderFns } from "./GetSupport.vue?vue&type=template&id=43f22666&"
import script from "./GetSupport.vue?vue&type=script&lang=js&"
export * from "./GetSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports